var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"is-stretched",attrs:{"type":_vm.type}},[_c('strong',[_vm._v(_vm._s(_vm.commission.amount_converted_formatted))])])}
var staticRenderFns = []

export { render, staticRenderFns }